<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChanged($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!completing"
  [style]="{ width: '560px', maxWidth: '95vw' }"
  [header]="headerKey | translate"
>
  <div class="fer-complete" [attr.aria-busy]="completing">
    @if (completing) {
      <p class="fvr-action-status" role="status">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>{{ 'FLEXI_EXPOSURE.FEEDBACK.COMPLETING' | translate }}
      </p>
    }

    @switch (stage) {
      @case ('ask') {
        <p>{{ 'FLEXI_EXPOSURE.COMPLETE.ASK_TEXT' | translate: { count: relevantCount, departments: relevantDepartmentCount } }}</p>
        <p class="fas-note">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>
            {{ 'FLEXI_EXPOSURE.COMPLETE.REPORT_NOTE' | translate }}
            <button type="button" class="fvr-link" (click)="openReport.emit()">{{ 'FLEXI_EXPOSURE.SUMMARY.PREVIEW_REPORT' | translate }}</button>
          </span>
        </p>
      }
      @case ('confirm') {
        <p>{{ 'FLEXI_EXPOSURE.COMPLETE.CONFIRM_TEXT' | translate }}</p>
        <p class="fas-note">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>{{ 'FLEXI_EXPOSURE.COMPLETE.REPORT_NOTE' | translate }}</span>
        </p>
      }
      @case ('form') {
        <form class="fer-complete__form" id="fer-complete-form" (ngSubmit)="completeWithActionPoint()" novalidate>
          <span class="fvr-eyebrow">{{ 'FLEXI_EXPOSURE.COMPLETE.FORM_EYEBROW' | translate }}</span>
          <div class="fvr-field">
            <label for="fer-measure">{{ 'FLEXI_EXPOSURE.COMPLETE.MEASURE' | translate }} <span class="fvr-required">*</span></label>
            <textarea
              pTextarea
              id="fer-measure"
              name="measure"
              rows="3"
              maxlength="4000"
              [(ngModel)]="measure"
              [attr.aria-invalid]="submitted && !measure.trim()"
              aria-describedby="fer-measure-error"
            ></textarea>
            @if (submitted && !measure.trim()) {
              <span class="fer-field-error" id="fer-measure-error">{{ 'FLEXI_EXPOSURE.COMPLETE.MEASURE_REQUIRED' | translate }}</span>
            }
          </div>
          <div class="fer-complete__grid">
            <div class="fvr-field">
              <label for="fer-ap-responsible">{{ 'FLEXI_COMPLIANCE.RESPONSIBLE.ADVISOR' | translate }} <span class="fvr-required">*</span></label>
              <p-select
                inputId="fer-ap-responsible"
                name="responsible"
                [options]="advisors"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="responsibleUserId"
                [filter]="true"
                appendTo="body"
                [placeholder]="'FLEXI_EXPOSURE.COMPLETE.CHOOSE_RESPONSIBLE' | translate"
                [attr.aria-invalid]="submitted && responsibleUserId === null"
                styleClass="fer-select"
              ></p-select>
              @if (submitted && responsibleUserId === null) {
                <span class="fer-field-error" role="alert">{{ 'FLEXI_EXPOSURE.COMPLETE.RESPONSIBLE_REQUIRED' | translate }}</span>
              }
            </div>
            <div class="fvr-field">
              <label for="fer-ap-deadline">{{ 'FLEXI_EXPOSURE.COMPLETE.DEADLINE' | translate }} <span class="fvr-required">*</span></label>
              <p-datepicker
                inputId="fer-ap-deadline"
                name="deadline"
                [(ngModel)]="deadline"
                [minDate]="minDeadline"
                dateFormat="dd-mm-yy"
                [showIcon]="true"
                appendTo="body"
                styleClass="fer-select"
              ></p-datepicker>
              @if (submitted && !deadline) {
                <span class="fer-field-error" role="alert">{{ 'FLEXI_EXPOSURE.COMPLETE.DEADLINE_REQUIRED' | translate }}</span>
              }
            </div>
          </div>
        </form>
      }
      @case ('done') {
        <ul class="fer-complete__results">
          <li>
            <div class="fer-complete__result-head">
              <strong>{{ 'FLEXI_EXPOSURE.COMPLETE.REPORT_SAVED' | translate }}</strong>
              <button type="button" class="fvr-link" (click)="openReport.emit()">{{ 'FLEXI_EXPOSURE.COMPLETE.OPEN' | translate }}</button>
            </div>
            <span class="fas-muted">{{ 'FLEXI_EXPOSURE.COMPLETE.REPORT_LOCATION' | translate: { title: assessmentTitle } }}</span>
          </li>
          @if (addedToPlan) {
            <li>
              <div class="fer-complete__result-head">
                <strong>{{ 'FLEXI_EXPOSURE.COMPLETE.ADDED_TO_PLAN' | translate }}</strong>
                <a class="fvr-link" [routerLink]="actionPointsUrl" (click)="close()">{{ 'FLEXI_EXPOSURE.COMPLETE.OPEN' | translate }}</a>
              </div>
              <span class="fas-muted">
                {{ 'FLEXI_EXPOSURE.COMPLETE.ACTION_SUMMARY' | translate: { name: responsibleName, date: (deadline | date: 'dd-MM-yyyy') } }}
              </span>
            </li>
          }
        </ul>
      }
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="fas-dialog-actions fer-complete__actions">
      @switch (stage) {
        @case ('ask') {
          <button type="button" class="fas-btn fas-btn--ghost" [disabled]="completing" (click)="completeWithoutActionPoint()">
            {{ 'FLEXI_EXPOSURE.COMPLETE.NO_JUST_COMPLETE' | translate }}
          </button>
          <button type="button" class="fas-btn fas-btn--primary" [disabled]="completing" (click)="showForm()">
            {{ 'FLEXI_EXPOSURE.COMPLETE.YES_ADD' | translate }}
          </button>
        }
        @case ('confirm') {
          <button type="button" class="fas-btn fas-btn--ghost" [disabled]="completing" (click)="close()">{{ 'CANCEL' | translate }}</button>
          <button type="button" class="fas-btn fas-btn--primary" [disabled]="completing" (click)="completeWithoutActionPoint()">
            @if (completing) {
              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            }
            {{ 'FLEXI_EXPOSURE.SUMMARY.COMPLETE' | translate }}
          </button>
        }
        @case ('form') {
          <button type="button" class="fas-btn fas-btn--ghost fer-complete__back" [disabled]="completing" (click)="backToAsk()">
            {{ 'FLEXI_EXPOSURE.BACK' | translate }}
          </button>
          <button type="submit" form="fer-complete-form" class="fas-btn fas-btn--primary" [disabled]="completing">
            @if (completing) {
              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            }
            {{ 'FLEXI_EXPOSURE.COMPLETE.ADD_AND_COMPLETE' | translate }}
          </button>
        }
        @case ('done') {
          <button type="button" class="fas-btn fas-btn--ghost" (click)="close()">{{ 'CLOSE' | translate }}</button>
          <button type="button" class="fas-btn fas-btn--primary" (click)="goToOverview()">
            {{ 'FLEXI_EXPOSURE.COMPLETE.BACK_TO_REGISTER' | translate }}
          </button>
        }
      }
    </div>
  </ng-template>
</p-dialog>
